module.exports = __webpack_public_path__ + "static/media/night-table-lamp-843461_1920.65059d06.jpg";